import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { LoaderProvider } from 'src/hooks/useLoader/LoaderContext';

const ProtectedRoutes: React.FC = (): React.ReactElement | null => {
	const { pathname, search } = useLocation();
	const isFromSubscription = pathname.includes('subscribe') || (decodeURIComponent(pathname) === '/רישום');

	const { isAuthenticated, refreshUser } = useAuth();
	const { i18n } = useTranslation();

	let link = '/en/login';
	if (i18n.language !== 'en') {
		link = 'כְּנִיסָה-לַמַעֲרֶכֶת';
	}

	useEffect(() => {
		if (!isAuthenticated()) {
			return;
		}
		refreshUser().then();
	}, []);

	return isAuthenticated()
		? <LoaderProvider>
			<Outlet/>
		</LoaderProvider>
		: <Navigate to={link} state={{
			redirectUrl: isFromSubscription ? pathname + search : null
		}}
		/>;
};

export default ProtectedRoutes;
